angular
  .module('resyApp')
  .filter('resySce', resySce);

function resySce($sce) {
  return function (value, type) {
    return $sce.trustAs(type || 'html', value);
  };
}

export default () => {};
